// components/configuration/TabNavigation.jsx
import React from 'react';

/**
 * Reusable tab navigation component
 * @param {Array} tabs - Array of tab objects with id, name, and icon
 * @param {string} activeTab - Currently active tab id
 * @param {Function} onTabChange - Callback when tab is clicked
 */
const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="border-b border-gray-200">
      <nav className="flex -mb-px">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`group inline-flex items-center px-6 py-4 border-b-2 font-medium text-sm transition-colors ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Icon className={`mr-2 h-5 w-5 ${
                isActive ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500'
              }`} />
              {tab.name}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default TabNavigation;
